import React from "react";

import { about } from "../data/Data";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';



export default function About() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h6 className="section-title text-start text-primary text-uppercase">
                About Us
              </h6>
              <h1 className="mb-4">
                Welcome to{" "}
                <span className="text-primary text-uppercase">
                  Sampath Residency
                </span>
              </h1>
              <p className="mb-4">
                SAMPATH RESIDENCY A/C boarding & lodging is a modern posh,
                luxury hotel, situated in the Very close to Palani Bus stand &
                Palani Hill Temple Sampath Residency 1km from palani Bus
                Stand and Palani Hill Temple 400m from Sampath Residency.
                It is ideally located and easily accessible, the railway
                station, bus stand & rope car within 5 minutes reach. SAMPATH
                RESIDENCY A/C boarding & lodging is tasteful, luxurious and
                designed to provide extreme comfort, making your stay just that
                little bit more memorable. Make your selection from different
                type of rooms, Air-Conditioned rooms and Non Air-Conditioned
                rooms, all of which are well furnished and equipped with modern
                amenities. The hotel is designed to provide a comfortable stay
              </p>
              <div className="row g-3 pb-4">
                {about.map((item, key) => (
                  <div className="col-sm-4 wow fadeIn" data-wow-delay="0.1s">
                    <div className="border rounded p-1">
                      <div className="border rounded text-center p-4">
                        {item.icon}
                        <h2 className="mb-1" data-toggle="counter-up">
                          {item.count}
                        </h2>
                        <p className="mb-0">{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <a className="btn btn-primary py-3 px-5 mt-2" href="/rooms">
                Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <div className="row g-3">
                <div className="col-6 text-end">
                  <img
                    alt=""
                    className="img-fluid rounded w-100"
                    data-aos="fade-up-right"
                    src="/assets/img/room-1.jpg"
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-6 text-start">
                  <img
                    alt=""
                    className="img-fluid rounded w-100"
                    data-aos="fade-up-left"
                    src="/assets/img/room-2.jpg"
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-6 text-end">
                  <img
                    alt=""
                    className="img-fluid rounded w-100"
                    data-aos="zoom-in-up"
                    src="/assets/img/room-3.jpg"
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                </div>
                <div className="col-6 text-start">
                  <img
                    alt=""
                    className="img-fluid rounded w-100"
                    data-aos="fade-up"
                    src="/assets/img/Room1.jpeg"
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </>
  );
}
